import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useLoginMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.authLoginCreate,
    onSuccess: () => client.resetQueries(),
  });
}
